import { IdentityValidationCommandActions, IdentityValidationQueryActions } from '@contexts/IdentityValidation/domain';
import { createContext, useContext } from 'react';
import { GqlIdentityValidationCommandActions, GqlIdentityValidationQueryActions } from '../gql/adapters';

type IdentityValidationActionsContextT = {
  identityValidationQueryActions: IdentityValidationQueryActions;
  identityValidationCommandActions: IdentityValidationCommandActions;
};

export const defaultValue: IdentityValidationActionsContextT = {
  identityValidationQueryActions: GqlIdentityValidationQueryActions,
  identityValidationCommandActions: GqlIdentityValidationCommandActions,
};

export const identityValidationActionsContext = createContext<IdentityValidationActionsContextT>(defaultValue);

export const useIdentityValidationActions = (): IdentityValidationActionsContextT =>
  useContext(identityValidationActionsContext);
